import { render, staticRenderFns } from "./EditTagsDialog.vue?vue&type=template&id=5dead89f&scoped=true&"
import script from "./EditTagsDialog.vue?vue&type=script&lang=js&"
export * from "./EditTagsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditTagsDialog.vue?vue&type=style&index=0&id=5dead89f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dead89f",
  null
  
)

export default component.exports